import { http } from '../lib/api/http';

const DEFAULT_CONTENT_TYPE = 'application/octet-stream';

export async function requestPresignedUpload({ kind, fileName, contentType }) {
  if (!kind) {
    throw new Error('Debes indicar el tipo de archivo a subir.');
  }
  const payload = {
    kind,
    file_name: fileName || kind,
    content_type: contentType || DEFAULT_CONTENT_TYPE,
  };
  const response = await http.post('/uploads/presign', payload);
  return response.data;
}

export async function uploadFileToSignedUrl(uploadUrl, file, contentType) {
  if (!uploadUrl) {
    throw new Error('No existe la URL de subida firmada.');
  }
  if (!(file instanceof Blob)) {
    throw new Error('Selecciona un archivo válido para subir.');
  }

  const headers = new Headers();
  headers.set('Content-Type', contentType || file.type || DEFAULT_CONTENT_TYPE);

  const res = await fetch(uploadUrl, {
    method: 'PUT',
    headers,
    body: file,
  });

  if (!res.ok) {
    const detail = await res.text().catch(() => '');
    throw new Error(detail || 'No se pudo subir el archivo a S3.');
  }
}

export async function uploadFileWithPresign({ kind, file }) {
  if (!(file instanceof File)) {
    throw new Error('Selecciona un archivo válido para subir.');
  }
  const presigned = await requestPresignedUpload({
    kind,
    fileName: file.name,
    contentType: file.type,
  });
  await uploadFileToSignedUrl(presigned.upload_url, file, file.type);
  return presigned;
}
